import WebServiceRequest from "../../Api/WebServiceRequest";

class MediaLibraryGetRequest extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Gallery/GetList");
  }
  setParams(data) {
    super.setRequestParamDataObj(data);
  }
}
export default MediaLibraryGetRequest;
